module.exports = __webpack_public_path__ + "media/images/salomon_banner/banner__between-c1e9384a01947a7a120b2237c397a363.jpg";